import { ReactElement, ReactNode } from "react";

import Table, { RowActions } from "~frontend/components/Table";

import { User } from "./types";

export default function UserTable<T extends User>({
  users,
  totalCount,
  rowsPerPage,
  onChangeRowsPerPage,
  page,
  onChangePage,
  renderRole,
  renderActions,
}: {
  users: T[];
  totalCount: number;
  rowsPerPage: number;
  onChangeRowsPerPage: (rpp: number) => void;
  page: number;
  onChangePage: (p: number) => void;
  renderRole: (user: T) => ReactNode;
  renderActions: (user: T) => RowActions<T>;
}): ReactElement {
  return (
    <Table
      columns={[
        {
          key: "name",
          title: "Name",
          renderValue: user => <span>{user.fullName}</span>,
        },
        {
          key: "email",
          title: "Email",
          renderValue: user => <span>{user.email}</span>,
        },
        { key: "role", title: "Role", renderValue: renderRole },
      ]}
      rows={users}
      rowActions={renderActions}
      totalCount={totalCount}
      rowsPerPage={rowsPerPage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      page={page}
      onChangePage={onChangePage}
    />
  );
}
